import { http, httpFile } from './http_service';

//Get all BDMs
export function allBDMs(){
  return http().get(`/bdm/all-bdms`);
}

//Get all
export function all(bdmId){
  return http().get(`/dashboard-bdm/all/${bdmId}`);
}
export function thisMonth(obj){
  return http().post(`dashboard-bdm/this-month`, obj);
}

export function lastMonth(obj){
  return http().post(`dashboard-bdm/last-month`, obj);
}

export function lastYear(obj){
  return http().post(`/dashboard-bdm/last-year`, obj);
}

export function thisMonthLeads(obj){
  return http().post(`dashboard-bdm/this-month-leads`, obj);
}

export function lastMonthLeads(obj){
  return http().post(`dashboard-bdm/last-month-leads`, obj);
}

export function lastYearLeads(obj){
  return http().post(`/dashboard-bdm/last-year-leads`, obj);
}

//Get BDM Commission
export function bdmCommissions(obj){
  return http().post(`/bdm/commissions`, obj);
}
export function bdmCommissionsDownload(obj){
  return http().post(`/bdm/commissions/download`, obj);
}
